import { SessionController } from '@core/helpers';
import { UncubesHTTPController } from './uncubesHTTPController';

export class UncubesQuery {
  projection = ''

  rows = []

  cols = []

  cuts = []

  orderBy = []

  aggregates = []

  limit = 25

  tenant = ''

  get #query() {
    return {
      query: {
        projection: this.projection,
        rows: this.rows,
        cols: this.cols,
        cuts: this.cuts,
        order_by: this.orderBy,
        aggregates: this.aggregates,
        limit: this.limit
      },
      app: 'Sudoku',
      tenant: `${SessionController.subdomain}_analytics`
    };
  }

  async execute() {
    const res = await UncubesHTTPController.getInstance().post('', this.#query);
    if (res.data.status !== 'processed' || !!res.data.error_message) {
      throw new Error(`${res.data.status} : ${res.data.error_message}`);
    }
    return res;
  }
}
